export const uk = {
    at: 'на',
    'at-percent': 'на {conversionInput} %',
    down: 'уменьшить',
    max: 'макс',
    min: 'мин',
    up: 'увеличить'
};
